import { Dialog, Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { Fragment } from "react"
import { Img } from "./image"
interface ComponentProps {
    children: any
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    panelClass?: string
    src: string
}
export const ImageViewer: React.FC<ComponentProps> = ({ children, isOpen, setIsOpen, panelClass, src }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className={`relative z-30`} onClose={() => setIsOpen((val => (!val)))}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={`w-fit p-4 transform  rounded-md align-middle transition-all ${panelClass}`}>
                                <button onClick={()=>setIsOpen(false)} className="outline-none shadow absolute p-2 rounded-full -right-1 -top-1 font-bold bg-white">
                                    <XMarkIcon className="h-4 w-4" />
                                </button>
                                <Img className="h-full w-auto" shouldOpenViewer={false} alt="" src={src} />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}